<template>
    <div>
      <div>
        <MenuAemps></MenuAemps>
      </div>
      <div class="crearAemps">
      <form v-on:submit.prevent="agregarCartas"  class="crear-cartas">
        <label for="principioActivo">Principio Activo</label>
          <input type="text" v-model="carta.principioActivo" id="principioActivo" required>
   
          <label for="nombreComercial">Nombre Comercial</label>
          <input type="text" v-model="carta.nombreComercial" id="nombreComercial" required>
          <label for="asunto">Asunto</label>
          <input type="text" v-model="carta.asunto" id="asunto" required>
          <label for="fecha">Fecha</label>
          <input type="text" v-model="carta.fecha" id="fecha"  placeholder="enero 24" required>
          <label for="fecha_publicacion_programada">Fecha de publicación programada</label>
          <VueDatePicker v-model="carta.fecha_publicacion_programada" :format-locale="es" locale="es" placeholder="Seleccione en el calendario la fecha de publicación" text-input />
          <label for="pdf">PDF:</label>
          <input type="file" name="pdf" id="pdfFile" @change="handleFileChange" >
        
          <button type="submit" class="btn">Agregar</button>
      </form></div>
    </div>
  </template>
  
  <script>
import MenuAemps from './MenuAemps.vue'
import VueDatePicker from '@vuepic/vue-datepicker';
import { es } from 'date-fns/locale';

export default {
  components: {
    MenuAemps,
    VueDatePicker,

  },
    data() {
      return {
        carta: {
          principioActivo: '',
          nombreComercial: '',
          asunto: '',
          fecha:'',
          fecha_publicacion_programada:'',
      },
      pdfFile: null,
      timezone: es,
      };
    },
    methods: {
      handleFileChange(event) {
        this.pdfFile = event.target.files[0];
      },
  
      agregarCartas() {
        console.log('Datos a enviar:', this.carta, this.pdfFile);
  
        // Crear objeto para enviar como JSON
        const datosEnviar = {
          principioActivo: this.carta.principioActivo,
          nombreComercial: this.carta.nombreComercial,
          asunto: this.carta.asunto,
          fecha: this.carta.fecha,
          fecha_publicacion_programada:this.carta.fecha_publicacion_programada,

        };
  
        // Crear FormData para enviar archivos
        const formData = new FormData();
  formData.append('pdf', this.pdfFile);
  formData.append('data', JSON.stringify(datosEnviar));

  // Enviar solicitud
  fetch('/php/lista.php?insertar=1', {
    method: 'POST',
    body: formData,
  })
    .then(response => response.json())
    .then(data => {
      console.log(data);
      if (data.success === 1) {
        // Datos y archivo PDF insertados correctamente
        window.location.href = 'listar';
        // Otra lógica que desees realizar después de la inserción exitosa
      } else {
        // Manejar el caso en que haya un error
        console.error('Error al insertar:', data.message);
        alert("Error al insertar: " + data.message);
      }
    })
    .catch(error => {
      console.error('Error al subir el PDF:', error);
      alert("Error al subir el PDF");
    });
  },
    },
  };
  </script>
  